// /* eslint react-hooks/exhaustive-deps: 0 */

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openPopup } from "../../reducers/popup";
import {
  userVoting,
  resetStatusUserVote,
  checkVoteOfUser,
} from "../../reducers/user";
import Modal from "./Modal";
import FormVote from "../FormVote";
import ModalHeader from "./ModalHeader";
const ModalVote = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state?.popup?.singer);
  const accessToken = useSelector((state) => state?.user?.profile?.accessToken);
  const resCode = useSelector((state) => state?.user?.userVoting?.code);
  const isLoadingVote = useSelector((state) => state?.user?.isLoadingVote);
  const [isVoteSuccess, setIsVoteSuccess] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(resetStatusUserVote());
    };
  }, []);

  useEffect(() => {
    if (resCode === 0 && accessToken) {
      setIsVoteSuccess(true);
      dispatch(checkVoteOfUser(accessToken));
    }
  }, [resCode, accessToken]);

  const hidePopup = () => {
    if (isLoadingVote) return;
    dispatch(openPopup({}));
  };

  const handleVote = (numberVote) => {
    dispatch(
      userVoting({ accessToken, objectId: data?.id, forecastNo: numberVote })
    );
    onToggleSuccess(true)
  };
  const onToggleSuccess = (isToggle) => {
    setIsVoteSuccess(isToggle)
  }
  return (
    <Modal onClose={hidePopup}>
      <div className="z-20 bg-[#000] max-h-[90vh] relative">
        <button
          onClick={hidePopup}
          className="absolute z-10 w-4 h-4 top-2 right-2"
          title="Close"
        >
          <svg
            className="w-4 h-auto"
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.8323 10.0156L19.6199 2.22773C20.1267 1.72117 20.1267 0.902117 19.6199 0.39555C19.1133 -0.111017 18.2943 -0.111017 17.7877 0.39555L9.99989 8.18339L2.21228 0.39555C1.70548 -0.111017 0.88667 -0.111017 0.380103 0.39555C-0.126701 0.902117 -0.126701 1.72117 0.380103 2.22773L8.16771 10.0156L0.380103 17.8034C-0.126701 18.31 -0.126701 19.129 0.380103 19.6356C0.632556 19.8883 0.964494 20.0152 1.29619 20.0152C1.62789 20.0152 1.95959 19.8883 2.21228 19.6356L9.99989 11.8478L17.7877 19.6356C18.0404 19.8883 18.3721 20.0152 18.7038 20.0152C19.0355 20.0152 19.3672 19.8883 19.6199 19.6356C20.1267 19.129 20.1267 18.31 19.6199 17.8034L11.8323 10.0156Z"
              fill="#fff"
            />
          </svg>
        </button>
        <div className="container modal-bg max-w-[500px] !min-h-[120vw] px-[4vw]">
          <ModalHeader
            disableSponsor
            classNamesContainer="relative top-0"
            classNamesLogoRapViet="max-w-[50%] 2xl:max-w-[580px] mx-auto pt-4"
            classNamesLogoBrand="2xl:-translate-y-20 max-w-[50%] mx-auto pt-4 md:-translate-y-10 -translate-y-6"
          />
          <div className="max-w-full form-vote-bg">
            <FormVote
              data={data}
              onSubmitVote={handleVote}
              isLoading={isLoadingVote}
              isVoteSuccess={isVoteSuccess}
              onToggleSuccess={onToggleSuccess}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalVote;
/* eslint react-hooks/exhaustive-deps: 0 */
